const templateConfig = [
    {
        name: 'default',
        header: 'default',
        footer: 'default',
        boosterbar: 'default',
    },
    {
        name: 'content_page_no_container',
        header: 'default',
        footer: 'default',
        boosterbar: 'none',
    },
    {
        name: 'checkout',
        header: 'reduced',
        footer: 'lite',
        boosterbar: 'default',
    },
    {
        name: 'delivery_search',
        header: 'reduced',
        footer: 'default',
        boosterbar: 'default',
    },
    {
        name: 'onboarding',
        header: 'none',
        footer: 'reduced',
        boosterbar: 'default',
    },
];

const getTemplateConfig = template => {
    let config = templateConfig.find(obj => obj.name === template);
    if (config) {
        return config;
    }
    return templateConfig.find(obj => obj.name === 'default');
};

export default getTemplateConfig;



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/templates/config.js